var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"float":"left","margin":"20px","margin-left":"0px","width":"150px","height":"110px","cursor":"pointer"},attrs:{"src":_vm.path,"alt":_vm.description},on:{"click":_vm.btnZoom}}),(_vm.preview)?_c('cImagePreview',{attrs:{"id":_vm.id,"table":_vm.table},on:{"close":_vm.setPreview}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }